function isMobile() {
  const ua = navigator.userAgent || "";
  const iPadOS = navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1;
  return /iPad|iPhone|iPod|Android/i.test(ua) || iPadOS;
}

export function resolveChannel(mode = "auto") {
  if (mode === "iprint") return "brother";
  if (mode === "system") return "system";
  return isMobile() ? "brother" : "system";
}

export function brotherUrl(pdfUrl, copies = 1) {
  return `brotherprint://v1/printlabel?media=62&copies=${copies}&url=${encodeURIComponent(pdfUrl)}`;
}

// Call synchronously inside the click handler (before any await) to avoid popup blockers.
export function preparePrint(settings = {}) {
  const channel = resolveChannel(settings.print_mode);
  const win = channel === "system" ? window.open("", "_blank") : null;
  return {
    channel,
    print(pdfUrl) {
      if (channel === "brother") {
        const a = document.createElement("a");
        a.href = brotherUrl(pdfUrl, settings.copies || 1);
        a.rel = "noopener";
        document.body.appendChild(a);
        a.click();
        a.remove();
        return;
      }
      const target = win || window.open(pdfUrl, "_blank");
      if (!target) return;
      target.location.href = pdfUrl;
      target.addEventListener("load", () => {
        try { target.focus(); target.print(); } catch (_) { /* viewer PDF: impression manuelle */ }
      });
    },
    cancel() {
      if (win) win.close();
    },
  };
}
